export const EFinixBuyerCardStatus = {
  Active: "active",
  Deleted: "deleted",
} as const;
export type TFinixBuyerCardStatus =
  (typeof EFinixBuyerCardStatus)[keyof typeof EFinixBuyerCardStatus];
